module.exports = __webpack_public_path__ + "static/img/room-img.7fc3ee9f.png";